import middleware from './middleware';
import instance from './instance';

export default {
  middleware,
  instance,
};
